import { render } from "./importAssessmentSuccessful.vue?vue&type=template&id=c0f4e506&scoped=true"
import script from "./importAssessmentSuccessful.vue?vue&type=script&lang=js"
export * from "./importAssessmentSuccessful.vue?vue&type=script&lang=js"

import "./importAssessmentSuccessful.vue?vue&type=style&index=0&id=c0f4e506&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f4e506"]])

export default __exports__